import React, { useEffect } from "react";
import Image from "../../src/images/logo .png";
import "../Css/Navbar.css";
import { Link } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min";

function Navbar() {
  useEffect(() => {
    const navbarCollapse = document.getElementById("navbarSupportedContent");
    if (navbarCollapse) {
      const bsCollapse = new window.bootstrap.Collapse(navbarCollapse, {
        toggle: false,
      });
      bsCollapse.hide();
    }
  }, []);

  const closeNavbar = () => {
    const navbarCollapse = document.getElementById("navbarSupportedContent");
    if (navbarCollapse.classList.contains("show")) {
      const bsCollapse = new window.bootstrap.Collapse(navbarCollapse, {
        toggle: false,
      });
      bsCollapse.hide();
    }
  };

  const handleToggleClick = () => {
    const navbarCollapse = document.getElementById("navbarSupportedContent");
    if (navbarCollapse.classList.contains("hide")) {
      closeNavbar();
    }
  };

  useEffect(() => {
    const dropdowns = document.querySelectorAll(".nav-item.dropdown");

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener("mouseenter", function () {
        let menu = this.querySelector(".dropdown-menu");
        if (menu) {
          menu.classList.add("show");
        }
      });

      dropdown.addEventListener("mouseleave", function () {
        let menu = this.querySelector(".dropdown-menu");
        if (menu) {
          menu.classList.remove("show");
        }
      });
    });
  }, []);



  return (
    <>
      <section className="container d-flex flex-column flex-md-row justify-content-start align-items-center vh-25 gap-3 gap-md-5 py-3">
        {/* Logo */}
        <div className="logo">
          <Link to="/">
            <img className="gkalogo" src={Image} alt="GKA" title="GKA" />
          </Link>
        </div>

        {/* Title */}
        <h3
          className="text-break text-center text-md-start fw-bold mx-auto mx-md-0"
          style={{
            color: "orange",
            maxHeight: "auto",
          }}
        >
          Gujarati Kshatriya Association <br className="d-none d-lg-block" />
          USA & Canada
        </h3>

        <div className="container">
          {/* Buttons Section */}
          <section className="d-flex justify-content-end gap-3 me-4 mt-0">
            <Link to="/Sponsormodel" className="text-decoration-none">
              <button
                className="btn text-white fw-bold px-4 py-2 border-dark border-2 rounded custom-btn"
                style={{ backgroundColor: "#F5951B" }}
              >
                BECOME A SPONSOR
              </button>
            </Link>

            <Link
              to="https://www.facebook.com/groups/268814586813648/?ref=share"
              className="text-decoration-none"
              target="_blank"
              rel="noopener noreferre"
            >
              <button
                className="btn text-white fw-bold px-4 py-2 rounded custom-btn  fb-btn"
                style={{ backgroundColor: "#F5951B" }}
              >
                Follow us on FB
              </button>
            </Link>
          </section>

          {/* Horizontal Line */}
          <hr
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              marginRight: "20%",
              Top: "15px",
            }}
          />

          {/* Contact Section */}

          <section className="container mt-4 header-section">
            <div className="row justify-content-between text-md-start text-center">
              {/* Email Section - Float Left on Desktop */}
              <div className="col-md-5 col-12 d-flex flex-column align-items-md-start align-items-center text-md-start text-center mb-3 mb-md-0 move-right-md">
                {/* Email Us Heading */}
                <strong className="mb-1 fs-5 text-center text-md-start ">
                  <strong className="email">Email Us:</strong>
                </strong>

                {/* Email with Icon */}
                <div className="d-flex align-items-center justify-content-center justify-content-md-start">
                  <Link
                    to="/"
                    className="text-dark text-decoration-none hover-effect"
                  >
                    gkana123@gmail.com
                  </Link>
                </div>
              </div>

              {/* Phone and Links Section - Float Right on Desktop */}
              <div className="col-md-5 col-12 d-flex flex-column align-items-md-end align-items-center text-md-end text-center me-md-4 reduce-top-space-md right-align-desktop">
                {/* Phone Number & Icon */}
                <div className="d-flex align-items-center justify-content-md-end justify-content-center">
                  <Link
                    to="/Contactus"
                    className="text-dark text-decoration-none icon-effect hover-effect callus"
                  >
                    <strong className="callus">Call Us:</strong>
                  </Link>
                </div>

                {/* Contact Us Link */}
                <Link
                  to="/Contactus"
                  className="text-dark text-decoration-none d-block mb-1 hover-effect"
                >
                  Contact us for any question
                </Link>

                {/* Committee Members Link */}
                <Link
                  to="/Contactus"
                  className="text-dark text-decoration-none d-block hover-effect"
                  style={{ marginRight: "45px" }}
                >
                  Committee Members
                </Link>
              </div>
            </div>
          </section>
        </div>
      </section>

      <style>
        {`
    /* iPad-specific styles */
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {
      /* Center logo, text, and buttons for iPads */
      .d-flex.flex-column.flex-md-row {
        justify-content: center !important;
        align-items: center !important;
        text-align: center !important;
      }

      /* Adjust logo size for iPads */
      .logo {
        max-width: 80px !important;
      }

      /* Adjust title font size for iPads */
      h3 {
        font-size: 1.5rem !important;
      }

      /* Adjust button size for iPads */
      .custom-btn {
        padding: 8px 16px !important;
        font-size: 0.9rem !important;
      }

      /* Center buttons for iPads */
      .d-flex.justify-content-end {
        justify-content: center !important;
      }

      /* Adjust horizontal line margin for iPads */
      hr {
        margin-left: 0 !important;
      }

      /* Center contact section for iPads */
      .header-section .col-md-5 {
        width: 100% !important;
        text-align: center !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
    }
  `}
      </style>

      <br />
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark custom-navbar-spacing mt-0">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={handleToggleClick}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto me-auto mb-2 mb-lg-0 nav-spacing gap-2 w-100  justify-content-center ">
              <li className="nav-item">
                <Link className="nav-link active" to="/" onClick={closeNavbar}>
                  <i className="bi bi-house-door-fill me-1"></i>
                </Link>
              </li>
              <li className="border-start border-light"></li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to="/"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  HOME
                </Link>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Appintroduction"
                      onClick={closeNavbar}
                    >
                      APP INTRODUCTION
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Commiteemember"
                      onClick={closeNavbar}
                    >
                      COMMITTEE MEMBERS
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="https://api.gkaglobal.org/gkawebsite/Privacy%20Policy.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={closeNavbar}
                    >
                      PRIVACY POLICY
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="border-start border-light"></li>

              <li className="nav-item">
                <Link
                  className="nav-link active"
                  to="/Aboutus"
                  onClick={closeNavbar}
                >
                  ABOUT US
                </Link>
              </li>

              <li className="border-start border-light"></li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to="/"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  GALLERY
                </Link>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Firstconvo"
                      onClick={closeNavbar}
                    >
                      1ST CONVO. 1998 LAS VEGAS
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Secondconvo"
                      onClick={closeNavbar}
                    >
                      2ND CONVO. 1999 DALLAS, TX
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Fourthconvo"
                      onClick={closeNavbar}
                    >
                      4TH CONVO. 2002 TORONTO, CA
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Fifthconvo"
                      onClick={closeNavbar}
                    >
                      5TH CONVO. 2004 ORLANDO,FL
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Sixthconvo"
                      onClick={closeNavbar}
                    >
                      6TH CONVO. 2007 EDISON,NJ
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Seventhconvo"
                      onClick={closeNavbar}
                    >
                      7TH CONVO. 2009 ATLANTA,GA
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Eightthconvo"
                      onClick={closeNavbar}
                    >
                      8TH CONVO. 2011 NB,CA
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="border-start border-light"></li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to="/"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  SOCIAL MEDIA
                </Link>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="https://parishad1925.org/hitechchhoo"
                      target="_blank"
                      rel="noopener noreferre"
                      onClick={closeNavbar}
                    >
                      HITECHCHHOO
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Newsletters"
                      onClick={closeNavbar}
                    >
                      NEWSLETTERS
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Manavseva"
                      onClick={closeNavbar}
                    >
                      MANAVSEVA
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Mochitimes"
                      onClick={closeNavbar}
                    >
                      MOCHI TIMES
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Worldwidemandals"
                      onClick={closeNavbar}
                    >
                      WORLD WIDE MANDALS
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="https://www.drikpanchang.com/gujarati/calendar/gujarati-calendar.html"
                      target="_blank"
                      rel="noopener noreferre"
                      onClick={closeNavbar}
                    >
                      GUJARATI CALENDER
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="border-start border-light"></li>

              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle"
                  to="/"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  CONTACT
                </Link>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li>
                    <hr className="dropdown-divider" />
                  </li>

                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Contactus"
                      onClick={closeNavbar}
                    >
                      CONTACT US
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/Commiteememberpage"
                      onClick={closeNavbar}
                    >
                      COMMITTEE MEMBERS PAGE
                    </Link>
                  </li>
                </ul>
              </li>

              <li className="border-start border-light"></li>
              <li className="nav-item">
                <Link
                  to="https://api.gkaglobal.org/gka"
                  target="_blank"
                  rel="noopener noreferre"
                >
                  <button
                    href="/membership" // Replace with your actual link
                    className="btn btn-custom btn-sm h-100 text-decoration-none"
                    onClick={closeNavbar}
                  >
                    BECOME A MEMBER
                  </button>
                </Link>
              </li>

              <li className="border-start border-light"></li>
              <li className="border-start border-light h-100"></li>

              <li className="nav-item">
                <a
                  href="https://api.gkaglobal.org/gka"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-custom btn-sm h-100 text-decoration-none"
                  onClick={closeNavbar}
                >
                  LOGIN
                </a>
              </li>
              <li className="border-start border-light"></li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
